import type { DataWorkerClient } from 'owa-data-worker-utils';
import { expose } from 'comlink';
import {
    applyTombstonesToSessionData,
    initialize,
    precompileSchema,
    getOfflineSessionData,
    saveOfflineSessionData,
    lazyFlushSyncLogs,
    lazyExecute,
    lazyUnsubscribe,
    lazyNotifySubscription,
    lazyInvokeWin32GqlRequestCallback,
    lazyInitializeDateTime,
    lazyInitializeApplicationSettings,
    lazyInitializeFeatureFlags,
    lazyInitializeOfflineSync,
    lazyGetOfflineTimeZoneOffsets,
    lazyGetOfflineTimeZones,
    lazyLoadOfflineSettings,
    lazySaveOfflineSettings,
    lazyInvalidateOfflineConversationNodes,
    lazyLogPeopleDataToSyncLogs,
} from 'owa-data-worker';
import { setDisableAllRequests } from './actions/setDisableAllRequests';
import {
    initializeAnalyticsInWorker,
    updateAnalyticsCachesInWorker,
} from 'owa-worker-analytics-initialization';

const client: DataWorkerClient = {
    initialize,
    initializeOfflineSync: lazyInitializeOfflineSync.importAndExecute,
    execute: lazyExecute.importAndExecute,
    unsubscribe: lazyUnsubscribe.importAndExecute,
    setDisableAllRequests,
    notifySubscription: lazyNotifySubscription.importAndExecute,
    flushSyncLogs: lazyFlushSyncLogs.importAndExecute,
    initializeDateTime: lazyInitializeDateTime.importAndExecute,
    initializeAnalyticsInWorker,
    updateAnalyticsCachesInWorker,
    initializeApplicationSettings: lazyInitializeApplicationSettings.importAndExecute,
    initializeFeatureFlags: lazyInitializeFeatureFlags.importAndExecute,
    precompileSchema,
    invokeWin32GqlRequestCallback: lazyInvokeWin32GqlRequestCallback.importAndExecute,
    getOfflineSessionData,
    saveOfflineSessionData,
    getOfflineTimeZones: lazyGetOfflineTimeZones.importAndExecute,
    getOfflineTimeZoneOffsets: lazyGetOfflineTimeZoneOffsets.importAndExecute,
    loadOfflineSettings: lazyLoadOfflineSettings.importAndExecute,
    saveOfflineSettings: lazySaveOfflineSettings.importAndExecute,
    invalidateOfflineConversationNodes: lazyInvalidateOfflineConversationNodes.importAndExecute,
    logPeopleDataToSyncLogs: lazyLogPeopleDataToSyncLogs.importAndExecute,
    applyTombstonesToSessionData,
};

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function expose called at module scope is not allowed. This may cause unwanted side effects. */
expose(client);
